export enum CenterTransplantStatus {    
    Active = 0,
    Suspended = 1
}